import { useEffect, useState, type ReactNode } from 'react';
import { cn } from '../ui/cn';

/**
 * Hero de service en deux colonnes: texte à gauche (petit titre dont le trait part du bord de l'écran, grand titre
 * qui monte dans un masque), grande photo à droite qui déborde jusqu'au bord et se dévoile de gauche à droite.
 */
export default function ServiceHero({ eyebrow, title, image, children }: { eyebrow: string; title: string; image?: string; children?: ReactNode }) {
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setSeen(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section data-seen={seen} className="relative overflow-hidden bg-white text-black">
      <div className="grid items-center lg:grid-cols-[minmax(0,1fr)_1.12fr]">
        <div className="px-6 py-12 md:px-8 lg:py-20 lg:pl-[max(2rem,calc((100vw-72rem)/2))] lg:pr-14">
          <div className="cs-eyebrow text-xs font-semibold uppercase tracking-[0.1rem] text-ink"><span className="cs-eyebrow-text inline-block">{eyebrow}</span></div>
          <div className="cs-mask mt-6 pb-2">
            <h1 className="cs-title font-display text-[2.5rem] font-bold normal-case leading-[1.05] tracking-normal text-black md:text-[3.75rem]" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{title}</h1>
          </div>
          {children && <div className="mt-8 max-w-xl">{children}</div>}
        </div>

        {/* Le coin supérieur droit est coupé en biais; le dévoilement de gauche à droite se joue à l'intérieur */}
        <div className="service-notch relative h-[26rem] sm:h-[30rem] lg:h-[56rem]">
          <div className={cn('absolute inset-0 overflow-hidden bg-secondary-200', seen && 'ps-reveal-img')} style={seen ? undefined : { clipPath: 'inset(0 100% 0 0)' }}>
            {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />}
          </div>
        </div>
      </div>
    </section>
  );
}
